/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageManufacturerResponse
 */
export interface UndercarriageManufacturerResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageManufacturerResponse
     */
    partGroup?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageManufacturerResponse
     */
    names?: string;
}

/**
 * Check if a given object implements the UndercarriageManufacturerResponse interface.
 */
export function instanceOfUndercarriageManufacturerResponse(value: object): value is UndercarriageManufacturerResponse {
    return true;
}

export function UndercarriageManufacturerResponseFromJSON(json: any): UndercarriageManufacturerResponse {
    return UndercarriageManufacturerResponseFromJSONTyped(json, false);
}

export function UndercarriageManufacturerResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageManufacturerResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'partGroup': json['partGroup'] == null ? undefined : json['partGroup'],
        'names': json['names'] == null ? undefined : json['names'],
    };
}

export function UndercarriageManufacturerResponseToJSON(json: any): UndercarriageManufacturerResponse {
    return UndercarriageManufacturerResponseToJSONTyped(json, false);
}

export function UndercarriageManufacturerResponseToJSONTyped(value?: UndercarriageManufacturerResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'partGroup': value['partGroup'],
        'names': value['names'],
    };
}

